module.exports = __webpack_public_path__ + "assets/img/icon_service15.28601830.png";